import React, { useRef, useCallback } from 'react'
import { Modal } from 'antd'
import { DefaultJsonForm } from 'src/react-app/components/default-json-form'
import { isFormDataRequired } from 'src/lib/utils/collections'
import { MapContent, MapWrapper } from './styles'
import range from 'lodash/range'

const UISchema = {
  'year': {
    css: {
      gridColumn: '1 / span 24',
      gridRow: '1',
    },
  },
}

const yearsList = range(2023, new Date().getFullYear() + 1).reverse()

const selectedSchema = {
  type: 'object',
  required: ['year'],
  properties: {
    year: {
      type: 'string',
      title: 'Выберите год',
      enum: yearsList,
      oneOf: yearsList.map(item => ({
        const: item,
        title: item.toString(),
      })),
      view: {
        name: 'select-from-enum',
      },
    },
  },
}

export function modalClose(event) {
  let target = event.target
  while (Boolean(target?.tagName) === true) {
    if (target?.tagName.toLowerCase() === 'div') {
      break
    }
    target = target?.parentNode
  }
  try {
    Array.from(target?.children as any[])[0].click()
    return true
  } catch {
    return false
  }
}

async function modalClaimsExport(): Promise<any> {
  let formData = {
    year: yearsList[0],
  }
  return new Promise(async resolve => Modal.confirm({
    icon: null,
    title: 'Экспорт в эксель',
    content: <Content UISchema={UISchema} onChange={value => {
      formData = value
    }} />,
    onCancel: () => resolve(null),
    okButtonProps: {
      onClick: async (event) => {
        const isRequired = isFormDataRequired(formData, selectedSchema)
        if (isRequired) {
          resolve(formData)
          modalClose(event)
        }
      },
    },
  }))
}

function Content({ onChange, UISchema }) {
  const formDataRef = useRef({
    year: yearsList[0],
  })
  const localOnChange = useCallback(({ formData }) => {
    formDataRef.current = formData
    onChange(formData)
  }, [onChange])

  return (
    <MapContent>
      <MapWrapper>
        <DefaultJsonForm
          formData={formDataRef.current}
          schema={selectedSchema}
          onChange={localOnChange}
          UISchema={UISchema}
        />
      </MapWrapper>
    </MapContent>
  )
}

export default modalClaimsExport